export enum CURRENCY {
  CHF = 'chf',
}

export const GENERAL_CURRENCY = CURRENCY.CHF
